import $ from 'jquery'
import Assures from '@/views/parametres/assurances/liste-assures/assures'
import ConventionDetail from '@/views/parametres/assurances/convention/convention-detail.vue'

export default {
	name: 'liste-assures',
	components: {
        Assures, ConventionDetail
    },
	props: [],
	data () {
		return {
            is_loading: true
		}
	},
	computed: {
        assureur() {
            return this.$store.getters["assureur"];
        },
        estConvention() {
            return !!this.assureur && this.assureur.type_tiers === 'convention';
        },
	},
	mounted () {
        this.$store.dispatch("getAssuranceById", this.$route.params.id).then(() => {
			this.is_loading = false
		});
	},
	methods: {
		changeTab(tabindex, t) {

            if (t == 1) {
                $('#shown-tab-' + tabindex).addClass('active show');

                for (let i = 1; i <= 4; i++) {
                    if (i != tabindex) {
                        $('#shown-tab-' + i).removeClass('active show');
                    }
                }
            } else {
                $('#hidden-tab-' + tabindex).addClass('active show');

                for (let i = 1; i <= 4; i++) {
                    if (i != tabindex) {
                        $('#hidden-tab-' + i).removeClass('active show');
                    }
                }
            }
        },
	}
}


